export const settingsRoot = '/settings'

export const settingsRoute = {
  profile: '/profile',
  company: '/company',
  notifications: '/notifications',
}
